export default "__VITE_ASSET__5nPWcYhW__"